import React from 'react';
import { connect } from 'react-redux';
import { Paper, IconButton } from 'material-ui';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import CopyToClipboard from 'react-copy-to-clipboard';
import get from 'lodash/get';
import head from 'lodash/head';
import { OddsList } from 'dash-front/odds';
import { setEventId, oddsSelection } from 'dash-front/odds/actions';
import EventPicker from 'dash-front/components/pickers/EventByDatePicker';
import { getEntities } from 'dash-front/selectors';
import { getUrlAndText, getUrlWithCampaign } from 'dash-front/odds/utils';
import { showSnackBarMessage } from 'dash-front/components/GlobalSnackbar';
import { fetchEventById } from 'dash-front/actions';

const MultilineText = ({ text }) => (
    <span>
        {(typeof text === 'string' ? text : '').split('\n').map((chunk, key) => (
            <span key={key}>
                {chunk}
                <br />
            </span>
        ))}
    </span>
);

const SelectionPreview = connect(state => {
    const { selectedOrder, selectedCampaign, selectedProvider, eventId } = oddsSelection.select(state);
    const { socialCampaigns, outcomes, betOffers, events = {} } = getEntities(state);
    return {
        outcomes,
        betOffers,
        socialCampaigns,
        selectedOrder,
        selectedCampaign,
        selectedProvider,
        event: events[eventId],
    };
})(({ selectedOrder, outcomes, betOffers, selectedProvider, event, socialCampaigns, selectedCampaign, dispatch }) => {
    const { url, text } = getUrlAndText({ selectedOrder, outcomes, betOffers, event, selectedProvider });
    const urlWithCampaign = url ? getUrlWithCampaign(url, socialCampaigns, selectedCampaign) : url;
    return (
        <div>
            <p>
                URL:{' '}
                {urlWithCampaign ? (
                    <span>
                        <i>{urlWithCampaign}</i>
                        <br />
                        <CopyToClipboard
                            text={urlWithCampaign}
                            onCopy={() => dispatch(showSnackBarMessage('URL was copied', 1500))}
                        >
                            <IconButton
                                disabled={!urlWithCampaign}
                                tooltip="Copy url to clipboard"
                                tooltipPosition="top-right"
                            >
                                <CopyIcon />
                            </IconButton>
                        </CopyToClipboard>
                    </span>
                ) : (
                    'none'
                )}
            </p>
            <div style={{ border: '2px solid #eee' }}>
                <MultilineText text={text} />
                <CopyToClipboard text={text} onCopy={() => dispatch(showSnackBarMessage('Text was copied', 1500))}>
                    <IconButton disabled={!text} tooltip="Copy text to clipboard" tooltipPosition="bottom-right">
                        <CopyIcon />
                    </IconButton>
                </CopyToClipboard>
            </div>
        </div>
    );
});

export const OddsScene = connect()(
    class extends React.Component {
        componentDidMount() {
            const { params, dispatch } = this.props;
            if (params.eventId) {
                dispatch(setEventId(params.eventId));
                dispatch(fetchEventById(params.eventId));
            }
        }

        componentWillReceiveProps({ params }) {
            if (params.eventId !== this.props.params.eventId) {
                this.props.dispatch(setEventId(params.eventId));
                if (params.eventId) {
                    this.props.dispatch(fetchEventById(params.eventId));
                }
            }
        }

        handleEventPickerChange = (keyChanged, value) => {
            if (keyChanged === 'eventId') {
                const {
                    router,
                    route: { path },
                } = this.props;
                router.push(path.replace(/\(?\/?:eventId\)?/, '/' + value));
            }
        };

        render() {
            return (
                <Paper style={{ padding: 12 }}>
                    <div>
                        <EventPicker eventId={this.props.params.eventId} onChange={this.handleEventPickerChange} />
                        <OddsList />
                        <SelectionPreview />
                    </div>
                </Paper>
            );
        }
    },
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/OddsScene.js
 **/